import { useState } from 'react'

export default function SubtitlePage() {
  const [subtitle, setSubtitle] = useState('')
  const [style, setStyle] = useState('默认')

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📝 字幕编辑</h2>

      <div style={{ background: '#fff', borderRadius: 8, padding: 24, maxWidth: 800 }}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#999', fontSize: 13 }}>字幕内容（每行一句）</label>
          <textarea value={subtitle} onChange={e => setSubtitle(e.target.value)} placeholder="00:00-00:05 第一句字幕内容"
            style={{ width: '100%', height: 200, padding: 12, border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, fontFamily: 'monospace', resize: 'none' }} />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#999', fontSize: 13 }}>字幕样式</label>
          <select value={style} onChange={e => setStyle(e.target.value)} style={{ padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14 }}>
            <option>默认</option>
            <option>描边</option>
            <option>阴影</option>
            <option>动态</option>
          </select>
        </div>

        <button style={{ padding: '12px 24px', background: '#fff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>应用字幕</button>
      </div>
    </div>
  )
}
